import { render, staticRenderFns } from "./Carrousel.vue?vue&type=template&id=6e8979b0&scoped=true"
import script from "./Carrousel.vue?vue&type=script&lang=js"
export * from "./Carrousel.vue?vue&type=script&lang=js"
import style0 from "./Carrousel.vue?vue&type=style&index=0&id=6e8979b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8979b0",
  null
  
)

export default component.exports